export var isEqualDate=function(a,b){return a.getTime()===b.getTime()};
//# sourceMappingURL=isEqualDate.js.map